import { createFileRoute } from '@tanstack/react-router';
import { ReorderSuggestionsReport } from '../../../features/reports/screens/ReorderSuggestionsReport';

/** Owned by G25. Report #10 — read-only reorder suggestions (the
 * purchasing-intake module's own `/purchasing-intake/reorder` additionally
 * offers one-click draft-PO creation — see that screen's own header). */
export const Route = createFileRoute('/_authenticated/reports/reorder')({
  component: ReorderSuggestionsReport,
});
